var scope_0 = require('/home/runner/work/degenalgorand.github.io/degenalgorand.github.io/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ee3381a5d71bd5ab405c893492191db5.js').default;export default
        Object.assign({}, scope_0 )
    